<template>
   <div class="card maxCaptl">
      <div class="card-header bg-transparent">
        <div class="row align-items-center">
            <div class="col violet">
              <h3><i class="fas fa-dollar-sign"></i>Max. Capital</h3>
            </div>
        </div>
      </div>
      <div class="input-group input-d mb-3">
      <small>Current Max. Capital: <b>$ {{new Intl.NumberFormat('en-US').format(maxCapital)}}</b></small>
        
      </div>
  </div>
</template>
<script>
export default {
  name: "setmaxcapital",
  props: ["bidSettings"],
  watch: {
    $props: {
      handler: function() {
        this.maxCapital = this.bidSettings.maxCapital;
      },
      deep: true
    }
  },
  data() {
    return {
      maxCapital : 0,
      
    };
  },
  methods: {

  },

  mounted() {
    
  }
};
</script>